import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Typography,
  Table,
  TableCell,
  TableBody,
  TableRow,
  TableHead,
  TableContainer, InputLabel, Select, MenuItem,
  Card,
  Autocomplete, createFilterOptions,
  TextField,
  FormControl,
  Grid,
  CardContent, Stack, DialogActions,
  Dialog,
  IconButton, Checkbox,
  InputAdornment,
  DialogContent,
  Container,
  Box,
  Breadcrumbs,
  Link,
} from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";

import Scrollbar from "src/components/Scrollbar";
import Page from "src/components/Page";
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import Iconify from "src/components/Iconify";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { getClientList } from "src/api/analytics";
import { newSubLogins, getSubLoginDetails, updateLoginDetails, DeleteLoginDetails } from "src/api/newSublogin";

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { faL } from "@fortawesome/free-solid-svg-icons";
import { getClientProperties } from "src/api/ShiftMaster";

const ClientConsolidationLogin = ({isReseller}) => {
  const theme = useTheme();
  const resellerClientType = (localStorage.getItem('client_type') || '').toUpperCase();
  const effectiveResellerClientType = resellerClientType === 'INDIA' ? 'INDIA' : 'US';


  //variable
  const [IsNeed2FAAuthentication, setIsNeed2FAAuthentication] = useState(0);
  const [value3, setValue3] = useState([]);
  const [email, setEmail] = useState("");
  const [agentName, setAgentName] = useState("");
  const [userNewName, setNewUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  //error 
  const [error, setError] = useState('')
  const [emailError, setEmailError] = useState("");
  const [agentNameError, setagentNameError] = useState('');
  const [userNewNameError, setuserNewNameError] = useState('');
  const [passwordError, setpasswordTypeError] = useState('');
  const [confirmPasswordError, setconfirmPasswordError] = useState('');


  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [visiblePasswordIndex, setVisiblePasswordIndex] = useState(null);


  const [userDetails, setUserDetails] = useState([]);

  //Edit Dailog box
  const [openDialogEdit, setOpenDialogEdit] = useState(false);

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('md');

  const [isEdited, setIsEdited] = useState(false)
  const [prvValue, setPrvValue] = useState('')

  const [rowData, setId] = useState([])

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);


  const [openMessage, setOpenMessage] = useState(false)
  const [isClientSelected, setIsClientSelected] = useState(false)
  const [clientList, setClientList] = useState([])
  const [subLogin, setSubLoginList] = useState([])
  const [subLoginSelect, setSubLoginSelectList] = useState([])

  //Multiple selection

  const [activeClients, setActiveClients] = useState([])
  const [openClientAuto, setOpenClientAuto] = useState(false)
  const [openEditClientAuto, setOpenEditClientAuto] = useState(false)
  const iconClient = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIconClient = <CheckBoxIcon fontSize="small" />;
  const [checkClientValue, setCheckClientValue] = useState(false)
  const [activeSelectedClients, setActiveSelectedClients] = useState([]);

  const [clientType, setClientType] = useState('')
  const [clientTypeerror, setClientTypeError] = useState('')
  const [setTypeClient, setSelectedTypeClient] = useState([]);
  const [clientEdit, setEditclient] = useState([]);

  const searchRef = useRef(null);
  const searchClientRef = useRef(null);
  const [inputSearch,setInputSearch] = useState('');
  const [inputClientSearch,setInputClientSearch] = useState('');

  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [locationError, setLocationError] = useState('');
  const [openLocationAuto, setOpenLocationAuto] = useState(false);
  const [editLocations, setEditLocations] = useState([]);
  const [editSelectedLocations, setEditSelectedLocations] = useState([]);
  const [editLocationError, setEditLocationError] = useState('');
  const [openEditLocationAuto, setOpenEditLocationAuto] = useState(false);
  const [initialEditLocationNames, setInitialEditLocationNames] = useState([]);

// Add this icon for location checkboxes
const iconLocation = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIconLocation = <CheckBoxIcon fontSize="small" />;

  const hasLocations = locations.length > 0;
  const hasEditLocations = editLocations.length > 0;

  const normalizeDisplayName = (name) =>
    String(name || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  const buildUniqueClientOptions = (clients) => {
    const grouped = new Map();

    (clients || []).forEach((clientItem) => {
      const key = normalizeDisplayName(clientItem?.displayname);
      if (!key) return;

      if (!grouped.has(key)) {
        grouped.set(key, []);
      }
      grouped.get(key).push(clientItem);
    });

    return Array.from(grouped.values()).map((groupItems) => {
      if (groupItems.length === 1) return groupItems[0];

      const assignTargets = new Set(
        groupItems
          .map((item) => Number(item.AssignClient || 0))
          .filter((assignId) => assignId > 0)
      );

      const mappedMain = groupItems.find((item) => assignTargets.has(Number(item.ID)));
      if (mappedMain) return mappedMain;

      const rootEntry = groupItems.find((item) => Number(item.AssignClient || 0) === 0);
      return rootEntry || groupItems[0];
    });
  };

  const filterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);

    // Separate selected and unselected options
    const selectedOptions = filtered.filter(option => activeClients.includes(option.ID));
    const unselectedOptions = filtered.filter(option => !activeClients.includes(option.ID));

    // Sort options: selected options first, then unselected
    const sortedOptions = [...selectedOptions, ...unselectedOptions];

    return [{ title: 'Select All', selectall: true }, ...filtered];
  };

  const handleClientChange = (event, value) => {
    let actClients = [];

    if (value.some(obj => obj.hasOwnProperty('selectall'))) {
      if (activeClients.length === setTypeClient.length) {
        setActiveClients([])
        setCheckClientValue(false)

        //alert('unchecked all')
        //tabRef.current = true;
        //handleDisplay()
      }
      else {
        setTypeClient.forEach(item => {
          actClients.push(item.ID)
        })
        setActiveClients(actClients)
        setCheckClientValue(true)


      }
    }
    else {
      let id = value[0].ID;
      if (activeClients.includes(id)) {
        let filterArr = activeClients.filter(client => client !== id);

        setActiveClients(filterArr);
        if (filterArr.length === 0) {
          //alert('unchecked all')
          // tabRef.current = true;
          //handleDisplay()
        }

        if (checkClientValue) {
          setCheckClientValue(false)
        }
      }
      else {
        setActiveClients((prv) => [...prv, id])
      }
    }
  }

  useEffect(() => {

    if (activeClients.length === setTypeClient.length ) {
      setCheckClientValue(true);
    }

    const fetchLocations = async () => {
    if (activeClients.length > 0) {
      // Clear previous locations and selected locations
      setLocations([]);
      setSelectedLocations([]);
      
      // Fetch locations for each selected client
      const locationPromises = activeClients.map(clientId => {
        const propertyBody = { AssignClient: Number(clientId) };
        return new Promise((resolve) => {
          getClientProperties(propertyBody, (response) => {
            if (response.status === 200) {
              resolve(response.data.map(loc => ({
                ...loc,
                clientId: clientId
              })));
            } else {
              resolve([]);
            }
          });
        });
      });

      const results = await Promise.all(locationPromises);
      const allLocations = results.flat();
      setLocations(allLocations);
    } else {
      setLocations([]);
      setSelectedLocations([]);
    }
  };

  fetchLocations();
  }, [activeClients])

  const handleLocationChange = (event, value) => {
  let actLocations = [];

  if (value.some(obj => obj.hasOwnProperty('selectall'))) {
    if (selectedLocations.length === locations.length) {
      setSelectedLocations([]);
    } else {
      locations.forEach(item => {
        actLocations.push(item.ID || item.id); // Adjust based on your location ID field
      });
      setSelectedLocations(actLocations);
    }
  } else {
    const locationId = value[0]?.ID || value[0]?.id; // Adjust based on your location ID field
    if (selectedLocations.includes(locationId)) {
      setSelectedLocations(selectedLocations.filter(id => id !== locationId));
    } else {
      setSelectedLocations([...selectedLocations, locationId]);
    }
  }
};

// Add this filter options for locations
const filterLocationOptions = (options, params) => {
  const filter = createFilterOptions();
  const filtered = filter(options, params);
  
  const selectedOptions = filtered.filter(option => 
    selectedLocations.includes(option.ID || option.id)
  );
  const unselectedOptions = filtered.filter(option => 
    !selectedLocations.includes(option.ID || option.id)
  );
  
  const sortedOptions = [...selectedOptions, ...unselectedOptions];
  
  return [{ title: 'Select Locations', selectall: true }, ...filtered];
};

const handleEditLocationChange = (event, value) => {
  let actLocations = [];

  if (value.some(obj => obj.hasOwnProperty('selectall'))) {
    if (editSelectedLocations.length === editLocations.length) {
      setEditSelectedLocations([]);
    } else {
      editLocations.forEach(item => {
        actLocations.push(item.ID || item.id);
      });
      setEditSelectedLocations(actLocations);
    }
  } else {
    const locationId = value[0]?.ID || value[0]?.id;
    if (editSelectedLocations.includes(locationId)) {
      setEditSelectedLocations(editSelectedLocations.filter(id => id !== locationId));
    } else {
      setEditSelectedLocations([...editSelectedLocations, locationId]);
    }
  }
};

const filterEditLocationOptions = (options, params) => {
  const filter = createFilterOptions();
  const filtered = filter(options, params);
  return [{ title: 'Select Locations', selectall: true }, ...filtered];
};

  // const handleClientChange = (event,value) =>{

  //   if(value==="add"){
  //     setDialogData({ ...dialogData, ClientID: event.target.value });
  //     setValue3(event.target.value)
  //   }
  //   else{
  //     seteditedData({...editedData,ClientID:event.target.value})
  //   }

  // }

  useEffect(() => {
    setCheckClientValue(false)
    getClientList((response) => {
      if (response.status === 200) {
        setClientList(response.data)
      }
    })
    const data = {
      type: 'merge'
    }
    getSubLoginDetails(data, (response) => {
      if (response.status === 200) {
        //console.log("getmergeLoginDetails", response.data);
        let activeClients = response.data.filter(val=>val.Status!==2)
        setSubLoginList(activeClients);
      }
    })

  }, [])



  const getEffectiveClientType = () => (isReseller ? effectiveResellerClientType : clientType);

  const setSubLoginByEffectiveType = (list) => {
    const effectiveType = getEffectiveClientType();
    const filteredSubLogins = (list || []).filter((row) => row.ClientType === effectiveType);
    setSubLoginSelectList(filteredSubLogins);
  };

  useEffect(() => {
    setCheckClientValue(false)
    const effectiveType = getEffectiveClientType();
    if (effectiveType === "INDIA") {
      // console.log("clientType", clientType)
      const indiaClients = clientList.filter((row) => row.ClientType === 'INDIA' && row.EnvironmentType !==0);
      const sortedData = [...indiaClients].sort((a,b)=>
        a.displayname.trim().localeCompare(b.displayname.trim())
      )
      setSelectedTypeClient(buildUniqueClientOptions(sortedData))
      setSubLoginByEffectiveType(subLogin)
    }
    else if (effectiveType === "US") {
      const usClients = clientList.filter((row) => row.ClientType === 'US' && row.EnvironmentType !==0);
      const sortedData = [...usClients].sort((a,b)=>
        a.displayname.trim().localeCompare(b.displayname.trim())
      )
      setSelectedTypeClient(buildUniqueClientOptions(sortedData))
      setSubLoginByEffectiveType(subLogin)
    }

  }, [clientType,clientList,isReseller,subLogin,effectiveResellerClientType])

  const [dialogData, setDialogData] = useState({
    // userType: '',
    agentName: '',
    mobileNumber: '',
    userNewName: '',
    password: '',
    confirmPassword: '',
    Email: '',
    IsNeed2FAAuthentication: 0
  });


  const [editedData, seteditedData] = useState({
    Id: '',
    UserID: '',
    agentName: '',
    userNewName: '',
    password: '',
    confirmPassword: '',
    Email: '',
    IsNeed2FAAuthentication: 0
  });

  const handleAgentNameChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, agentName: event.target.value });
      setAgentName(event.target.value)
    }
    else {
      seteditedData({ ...editedData, agentName: event.target.value })
    }
  };

  const handleAuthenicationChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, IsNeed2FAAuthentication: event.target.value });
      setIsNeed2FAAuthentication(event.target.value);
      if (String(event.target.value) !== '1') {
        setEmailError('');
      }
    } else {
      seteditedData({ ...editedData, IsNeed2FAAuthentication: event.target.value });
      if (String(event.target.value) !== '1') {
        setEditEmailError('');
      }
    }
  };

  const handleEmailChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, Email: event.target.value });
      setEmail(event.target.value);
      setEmailError('');
    } else {
      seteditedData({ ...editedData, Email: event.target.value });
      setEditEmailError('');
    }
  };


  const handleUsername = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, userNewName: event.target.value });
      setNewUsername(event.target.value)
    }
    else {
      setIsEdited(true)
      setPrvValue(editedData.userNewName)
      seteditedData({ ...editedData, userNewName: event.target.value })
    }
  };

  const handlePasswordChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, password: event.target.value });
      setPassword(event.target.value)
    }
    else {
      seteditedData({ ...editedData, password: event.target.value })
    }
  };

  const handleConfirmPasswordChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, confirmPassword: event.target.value });
      setConfirmPassword(event.target.value)
    }
    else {
      seteditedData({ ...editedData, confirmPassword: event.target.value })
    }
  };


  // const handleEditedImageChange = (event) => {
  //   // console.log(event.target.files[0])
  //   seteditedData({ ...editedData, image: event.target.files[0] });
  // };

  function isUniqueValue(newDisplayName, newUserName, newEmail, subLogin) {
    let isValid = true;

    if (newDisplayName === newUserName) {
      setagentNameError("Profile Name and User Name should be different");
      setuserNewNameError("Profile Name and User Name should be different");
      isValid = false;
    }

    for (const login of subLogin) {
        const loginDisplayName =  login.DisplayName.trim();
        const loginUserName =  login.UserName.trim();
        const loginEmail = (login.Email == null ? "" : login.Email).trim();

        if (loginDisplayName === newDisplayName) {
          setagentNameError("Profile Name Already Exist");
          isValid = false
        }
        if(loginUserName === newUserName){
          setuserNewNameError("User Name Already Exist");
          isValid = false
        }

        if (newEmail && loginEmail === newEmail) {
          setEmailError("Email Already Exists");
          isValid = false
        }
    }
    return isValid; // Return true if no match is found
  }

  function isUniqueEditValue(newDisplayName, newUserName, newEmail, subLogin) {
    // console.log(editedData)
    let id = editedData.Id
    let isValid = true;

    if(newDisplayName === newUserName){
      setEditProfileNameError("Profile Name and User Name should be different");
      setEditNameError("Profile Name and User Name should be different");
      isValid = false
    }

    // console.log(subLogin)
    for (const login of subLogin) {
        if (login.Id === id) continue;

        const loginDisplayName =  login.DisplayName.trim();
        const loginUserName =  login.UserName.trim();
        const loginEmail = (login.Email == null ? "" : login.Email).trim();

        if (loginDisplayName === newDisplayName && login.Id !== id) {
          setEditProfileNameError("Profile Name Already Exist");
          isValid = false
        }
        if(loginUserName === newUserName && login.Id !== id){
          setEditNameError("User Name Already Exist");
          isValid = false
        }    
        
        if(newEmail && loginEmail === newEmail && login.Id !== id){
          setEditEmailError("Email Already Exist");
          isValid = false
        } 
    }
    return isValid; // Return true if no match is found
  }


  const handleSubmit = () => {
    // console.log("values ", activeClients, agentName, userNewName, password, confirmPassword, clientType)
    let Count = 0;
    // setuserTypeError('')
    setError('')
    setagentNameError('')
    setuserNewNameError('')
    setEmailError('');
    setpasswordTypeError('')
    setconfirmPasswordError('')
    setClientTypeError('')
    setLocationError('')

    if (activeClients.length === 0) {
      setError("Please Select the Client")
    }

    if (hasLocations && selectedLocations.length === 0) {
      setLocationError("Please Select at least one Location")
      Count = 1;
    }

    const addUserNewName = userNewName.trim();
    const addEmail = email.trim();
    const addPassword = password.trim();
    const addConfirmPassword = confirmPassword.trim();
    const addAgentName = agentName.trim();

    if (String(IsNeed2FAAuthentication) === '1' && !addEmail) {
      setEmailError("Please Enter the Email")
      Count = 1;
    }

    // Check for valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (addEmail && !emailRegex.test(addEmail)) {
      setEmailError("Please Enter the Valid Email");
      Count = 1;
    }

    if (!addAgentName) {
      setagentNameError("Please Enter the Profile Name");
      Count = 1;
    }
    
    if (!addUserNewName) {
      setuserNewNameError("Please Enter the User Name");
      Count = 1;
    }
    
    if(!addPassword){
      setpasswordTypeError("Please Enter the Password")
      Count = 1;
    }
    if(!addConfirmPassword){
      setconfirmPasswordError("Please Enter the Confirm Password")
      Count = 1;
    }

    if(password != confirmPassword){
      setconfirmPasswordError("Password and Confirm Password not Matching")
      Count = 1;
    }


    if (Count === 0) {

      if (!isUniqueValue(addAgentName, addUserNewName, addEmail, subLogin)) {
        // console.log("The agentName or userNewName already exists in the list.");
        // Modify the new values to be unique
        // For example, append some random number or string to ensure uniqueness

      }
      else{
        const selectedLocationItems = hasLocations
          ? locations.filter((loc) => selectedLocations.includes(loc.ID || loc.id))
          : [];
        const selectedLocationIds = selectedLocationItems
          .map((loc) => loc.ID || loc.id)
          .join(',');
        const selectedLocationNames = selectedLocationItems
          .map((loc) => loc.Location || loc.name || '')
          .join(', ');
        const data = {
          UserID: hasLocations ? selectedLocationIds : activeClients.join(','),
          displayname: addAgentName,
          Name: addUserNewName,
          Password:addPassword,
          Email: addEmail,
          IsNeed2FAAuthentication: IsNeed2FAAuthentication,
          Location: selectedLocationNames,
          Type: "merge"
        }

        
        // console.log("data", data);
        newSubLogins(data, (response) => {
          if (response.status === 200) {
            // console.log("new merge login data ", response.data)
            //handleClear();

            setAgentName('');
            setNewUsername('');
            setPassword('');
            setConfirmPassword('');
            setEmail('');

            const data = {
              type: 'merge'
            }
            getSubLoginDetails(data, (response) => {
              if (response.status === 200) {
                // console.log("getSubLoginDetails", response.data);
                setSubLoginList(response.data);
                let result = response.data;
                setSubLoginByEffectiveType(result)
                setActiveClients([])
              }
            })
          }
        })
      }
    }
  };

  const handleClear = () => {
    // setUserType('');
    setError('')
    setAgentName('');
    setEmail('');
    setIsNeed2FAAuthentication(0);
    // setMobileNumber('');
    setNewUsername('');
    setPassword('');
    setConfirmPassword('');
    // setImage(null);
    setClientType('');
    setClientTypeError('')
    // setuserTypeError('')
    setagentNameError('')
    // setmobileNumberError('')
    setuserNewNameError('')
    setEmailError('');
    setpasswordTypeError('')
    setconfirmPasswordError('')
    setLocationError('')
    setSelectedLocations([]) 
    setLocations([]) 
    //setSubLoginList([])
    //setSubLoginSelectList([])
    // setImageError('')
    // console.log(subLoginSelect)
    if (subLoginSelect.length > 0) {
      setSubLoginSelectList([])
    }

  }

  const handleEdit = (data) => {
    
    editclientList(data.ClientType);

    const filteredClients = clientList.filter(client =>
      data.ClientId.includes(client.ID)
    );

    const initialSelectedClients = filteredClients.map((client) => client.ID);
    setActiveSelectedClients(initialSelectedClients);
    setEditSelectedLocations([]);
    setEditLocationError('');
    setInitialEditLocationNames(formatLocationsForDisplay(data.Location));

    // console.log("filteredClients", filteredClients);
    // console.log("selectedClient ", data.ClientId);

    setShowMessage(false)
    // if(data.Password === confirmPassword)
    seteditedData({
      Id: data.Id,
      agentName: data.DisplayName,
      userNewName: data.UserName,
      password: data.Password,
      confirmPassword: data.Password,
      UserID: filteredClients,
      Email: data.Email || '',
      IsNeed2FAAuthentication: parseInt(data.IsNeed2FAAuthentication || 0)
    })
    setOpenDialogEdit(true);
  };

  const editclientList = (type) => {
    // console.log("type ===", type);

    if (type === "INDIA") {
      // console.log("clientType", clientType)
      const indiaClients = clientList.filter((row) => row.ClientType === 'INDIA');
      setEditclient(buildUniqueClientOptions(indiaClients))

    }
    else if (type === "US") {
      const usClients = clientList.filter((row) => row.ClientType === 'US');
      setEditclient(buildUniqueClientOptions(usClients))
    }
  }

  const [editclientError, setEditClientError] = useState('')
  const [editNameError, setEditNameError] = useState('')
  const [editProfileNameError, setEditProfileNameError] = useState('')
  const [editEmailError, setEditEmailError] = useState('')

  // const [mobileError, setMobileError] = useState('')
  const [editedPasswordError, setEditedPasswordError] = useState('')
  const [editedConfirmPasswordError, setEditedConfirmPasswordError] = useState('')

  const [showMessage, setShowMessage] = useState(false)

  const handleUpdated = () => {
    
    setEditEmailError('');
    setEditClientError('');
    setEditNameError('');
    setEditProfileNameError('');
    setEditedPasswordError('')
    setEditedConfirmPasswordError('');
    setEditLocationError('');
    
    // console.log("activeSelectedClients ", activeSelectedClients);
    let count = 0

    if(activeSelectedClients.length===0){
      // console.log(editedData)
      let data = {"ID":editedData.Id}
      DeleteLoginDetails(data,(response)=>{
        // console.log(response)
        if(response.status===200){
          setOpenDialogEdit(false); 
            const data = {
              type: 'merge'
            }
            getSubLoginDetails(data, (response) => {
              if (response.status === 200) {
                // console.log("getSubLoginDetails", response.data);
                let activeClients = response.data.filter(val=>val.Status!==2)
                setSubLoginList(activeClients);
                let result = activeClients;
                setSubLoginByEffectiveType(result)
              }
            })
          }
        })
      return
    }

    if (hasEditLocations && editSelectedLocations.length === 0) {
      setEditLocationError("Please Select at least one Location");
      count = 1;
    }


    const editedEmail = editedData.Email.trim();
    const editedAgentName = editedData.agentName.trim();
    const editedUserNewName = editedData.userNewName.trim();
    const editedPassword = editedData.password.trim();
    const editedConfirmPassword = editedData.confirmPassword.trim();
    const editedIsNeed2FAAuthentication = editedData.IsNeed2FAAuthentication;

    // console.log("updateData==", updateData)
    // if (activeSelectedClients.length === 0) {
    //   setEditClientError("please select the client")
    //   count = 1
    // }


    if (String(editedIsNeed2FAAuthentication) === '1' && !editedEmail) {
      setEditEmailError("Please Enter the Email");
      count = 1
    }

    // Check for valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (editedEmail && !emailRegex.test(editedEmail)) {
      setEditEmailError("Please Enter the Valid Email");
      count = 1;
    }

    if (!editedAgentName) {
      setEditProfileNameError("Please Enter the Profile Name");
      count = 1
    }
    
    if (!editedUserNewName) {
      setEditNameError("Please Enter the User Name");
      count = 1
    }

    if (!editedPassword) {
      setEditedPasswordError("Please Enter the Password");
      count = 1
    }
    
    if (!editedConfirmPassword) {
      setEditedConfirmPasswordError("Please Enter the Confirm Password");
      count = 1
    }
    
    if (editedPassword !== editedConfirmPassword) {
      setEditedPasswordError("Password and Confirm Password not Matching");
      setEditedConfirmPasswordError("Password and Confirm Password not Matching");
      count = 1
    }
    
    
    const updateData = {
      ID: editedData.Id,
      UserID: `${activeSelectedClients}`,
      displayname: editedAgentName,
      Name: editedUserNewName,
      Password: editedPassword,
      Type: "merge",
      Status: 1,
      Email:editedEmail,
      IsNeed2FAAuthentication: parseInt(editedIsNeed2FAAuthentication),
      Location: hasEditLocations
        ? editLocations
            .filter(loc => editSelectedLocations.includes(loc.ID || loc.id))
            .map(loc => loc.Location || loc.name || '')
            .join(', ')
        : ''
    }


    if (activeSelectedClients.length!==0 && count === 0 && editedPassword === editedConfirmPassword && updateData.UserID !== '' && updateData.UserID !== null && editedPassword !== '' && editedPassword !== null && editedAgentName !== '' && editedAgentName !== null && editedUserNewName !== '' && editedUserNewName !== null) {
     

      if (!isUniqueEditValue(editedAgentName, editedUserNewName, editedEmail, subLogin)) {
        // console.log("The agentName or userNewName already exists in the list.");
        // Modify the new values to be unique
        // For example, append some random number or string to ensure uniqueness
      }
      else{
        updateLoginDetails(updateData, (response) => {
          if (response.status === 200) {
            setOpenDialogEdit(false);
  
            const data = {
              type: 'merge'
            }
            getSubLoginDetails(data, (response) => {
              if (response.status === 200) {
                // console.log("getSubLoginDetails", response.data);
                setSubLoginList(response.data);
                let result = response.data;
                setSubLoginByEffectiveType(result)
              }
            })
          }
        })
      }
    }


  }

  const handleClose = () => {
    setOpenDialogEdit(false);
    setIsEdited(false)
    setPrvValue('')
    setEditNameError('')
    setEditEmailError('');
    setEditedPasswordError('')
    setShowMessage(false)
    setOpenMessage(false)
    setEditClientError('');
    setEditProfileNameError('');
    setEditedConfirmPasswordError('');
    setEditLocations([]);
    setEditSelectedLocations([]);
    setEditLocationError('');
    setInitialEditLocationNames([]);
  };


  const handleDisable = (data) => {
    // Add your disable logic here
    // console.log("data...", data);
    setOpenMessage(true)
    // let Id=data.ID?data.ID:0
    setId(data)

  };

  const disableUser = () => {

    // console.log("rowData", rowData);
    const disable = {
      ID: rowData.Id,
      UserID: `${rowData.ClientId}`,
      displayname: rowData.DisplayName,
      Name: rowData.UserName,
      Password: rowData.Password,
      Email: rowData.Email,
      IsNeed2FAAuthentication: parseInt(rowData.IsNeed2FAAuthentication),
      Type: "merge",
      Status: rowData.Status === 0 ? 1 : 0,
    }

    // console.log("disbale option ", disable)

    updateLoginDetails(disable, (response) => {

      if (response.status === 200) {
        setOpenMessage(false)
        const data = {
          type: 'merge'
        }
        getSubLoginDetails(data, (response) => {

          if (response.status === 200) {
            // console.log("getSubLoginDetails", response.data);
            setSubLoginList(response.data);
            //console.log(subLoginSelect)
            let result = response.data;
            setSubLoginByEffectiveType(result)

          }
        })
      }
    })
  }


  // Function to handle the icon click
  const handlePasswordVisibilityToggle = (index) => {
    setVisiblePasswordIndex(visiblePasswordIndex === index ? null : index);
  };




  const sortedClients = clientEdit.sort((a, b) => {
    const isSelectedA = activeSelectedClients.includes(a.ID);
    const isSelectedB = activeSelectedClients.includes(b.ID);
    return isSelectedB - isSelectedA; // Move selected ones to the top
  });



  const handleClientType = (event) => {
    // console.log("client type",event.target.value)
    setActiveClients([])

    setClientType(event.target.value)

    setError('')
    setAgentName('');
    // setMobileNumber('');
    setNewUsername('');
    setPassword('');
    setConfirmPassword('');
    setEmail('');
    setIsNeed2FAAuthentication(0);
    // setImage(null);
    // setClientType('');
    // setClientTypeError('')
    // setuserTypeError('')
    setagentNameError('')
    setEmailError('');
    // setmobileNumberError('')
    setuserNewNameError('')
    setpasswordTypeError('')
    setconfirmPasswordError('')
  }

  const formatLocationsForDisplay = (rawLocation) => {
    if (rawLocation === null || rawLocation === undefined) return [];

    let locationValues = [];

    if (Array.isArray(rawLocation)) {
      locationValues = rawLocation;
    } else if (typeof rawLocation === 'string') {
      const trimmedLocation = rawLocation.trim();
      if (!trimmedLocation) return [];

      try {
        if (trimmedLocation.startsWith('[') && trimmedLocation.endsWith(']')) {
          const parsedLocation = JSON.parse(trimmedLocation);
          if (Array.isArray(parsedLocation)) {
            locationValues = parsedLocation;
          } else {
            locationValues = [trimmedLocation];
          }
        } else {
          locationValues = trimmedLocation.split(',');
        }
      } catch {
        locationValues = trimmedLocation.split(',');
      }
    } else {
      locationValues = [rawLocation];
    }

    return locationValues
      .map((value) => String(value ?? '').trim())
      .filter((value) => value !== '');
  };

  const parseClientIds = (rawClientId) => {
    if (Array.isArray(rawClientId)) {
      return rawClientId.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
    }

    if (typeof rawClientId === 'string') {
      const trimmed = rawClientId.trim();
      if (!trimmed) return [];

      try {
        if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return parsed.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
          }
        }
      } catch {
        // fallback handled below
      }

      return trimmed
        .split(',')
        .map((id) => Number(String(id).trim()))
        .filter((id) => !Number.isNaN(id));
    }

    const numericId = Number(rawClientId);
    return Number.isNaN(numericId) ? [] : [numericId];
  };

  const formatClientWithLocation = (client) => {
    if (!client) return '';
    return `${client.displayname || ''}`.trim();
  };

  const getClientLabelsForRow = (row) => {
    const clientIds = parseClientIds(row?.ClientId);
    const mappedLabels = clientIds
      .map((id) => clientList.find((client) => Number(client.ID) === Number(id)))
      .filter(Boolean)
      .map((client) => formatClientWithLocation(client));

    if (mappedLabels.length > 0) return mappedLabels;

    if (Array.isArray(row?.ClientName)) {
      return row.ClientName.map((name) => String(name || '').trim()).filter(Boolean);
    }

    if (row?.ClientName) return [String(row.ClientName).trim()];
    return [];
  };

  useEffect(() => {
    const fetchEditLocations = async () => {
      if (!openDialogEdit || activeSelectedClients.length === 0) {
        setEditLocations([]);
        setEditSelectedLocations([]);
        return;
      }

      const locationPromises = activeSelectedClients.map(clientId => {
        const propertyBody = { AssignClient: Number(clientId) };
        return new Promise((resolve) => {
          getClientProperties(propertyBody, (response) => {
            if (response.status === 200) {
              resolve(response.data.map(loc => ({
                ...loc,
                clientId
              })));
            } else {
              resolve([]);
            }
          });
        });
      });

      const results = await Promise.all(locationPromises);
      const allLocations = results.flat();
      setEditLocations(allLocations);

      const allLocationIds = new Set(allLocations.map((loc) => loc.ID || loc.id));
      setEditSelectedLocations((prev) => {
        if (prev.length > 0) {
          return prev.filter((id) => allLocationIds.has(id));
        }

        const expected = new Set(
          initialEditLocationNames.map((name) => String(name || '').trim().toLowerCase())
        );
        if (expected.size === 0) return [];

        const defaultSelected = allLocations
          .filter((loc) => expected.has(String(loc.Location || loc.name || '').trim().toLowerCase()))
          .map((loc) => loc.ID || loc.id);

        return [...new Set(defaultSelected)];
      });
    };

    fetchEditLocations();
  }, [openDialogEdit, activeSelectedClients, initialEditLocationNames]);

  const handleInputChange = (event, newInputValue) => {
    // console.log(searchRef.current.value)
    setInputSearch(searchRef.current.value); 
  };

  const handleInputClientChange = (event, newInputValue) => {
    setInputClientSearch(searchClientRef.current.value); 
  };

  return (
    <Page title="Client Consolidation Login">
      <Container maxWidth="xxl" sx={{ p: 0 }}>
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Client Consolidation Login</Typography>
          </Box>
          <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.secondary" sx={{ fontSize: '0.875rem' }}>Settings</Typography>
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>Client Consolidation Login</Typography>
          </Breadcrumbs>
        </Box>
        <Card variant="outlined" sx={{ p: 0 }}>
          <CardContent sx={{p:2}}>
            <Grid container spacing={2} alignItems="center" marginTop={0}>
              {!isReseller && (<Grid item md={1}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-labell">Client Type</InputLabel>
                  <Select

                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={clientType}
                    label="Client Type"
                    onChange={handleClientType}
                    // helperText={touched.ClientType && errors.ClientType}
                    error={clientTypeerror ? true : false}
                  >

                    <MenuItem value="US">US</MenuItem>
                    <MenuItem value="INDIA">INDIA</MenuItem>

                  </Select>
                  {clientTypeerror && <Typography variant="body2" color="error">{clientTypeerror}</Typography>}
                </FormControl>
              </Grid>)}

              <Grid item xs={3}>
                <Autocomplete
                  multiple
                  fullWidth
                  id="client"
                  options={setTypeClient}
                  value={[]}
                  getOptionLabel={(option) => (option.selectall && setTypeClient.length === activeClients.length) ? 'Select All' : `${option.displayname || ''}`}
                  inputValue={inputClientSearch} 
                  onInputChange={handleInputClientChange}
                  onChange={handleClientChange}
                  disableCloseOnSelect={openClientAuto}
                  open={openClientAuto}
                  onOpen={() => setOpenClientAuto(true)}
                  onClose={() => setOpenClientAuto(false)}
                  filterOptions={filterOptions}
                  renderOption={(props, option, { selected }) => {
                    const key = `camid-${option.ID}`;
                    return (
                      <li {...props} key={key}>
                        {option.selectall ? (
                          <>
                            <Checkbox
                              icon={iconClient}
                              checkedIcon={checkedIconClient}
                              style={{ marginRight: 8 }}
                              checked={checkClientValue}
                            //onChange={() => setCheckClientValue(!checkClientValue)}
                            />
                            {option.title}
                          </>
                        ) : (
                          <>
                            <Checkbox
                              icon={iconClient}
                              checkedIcon={checkedIconClient}
                              style={{ marginRight: 8 }}
                              checked={activeClients.includes(option.ID)
                                // || selectedClient.some(client => client.ID === option.ID)
                              }
                              onChange={() => {
                                const isChecked = activeClients.includes(option.ID);
                                const newActiveClients = isChecked
                                  ? activeClients.filter((clientId) => clientId !== option.ID)
                                  : [...activeClients, option.ID];
                                setActiveClients(newActiveClients);
                              }}
                            />
                              {`${option.displayname || ''}`}
                          </>
                        )}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField 
                      inputRef={searchClientRef}
                      {...params} 
                      label="Client" 
                      onFocus={() => setOpenClientAuto(true)} 
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <InputAdornment position="end">
                            {activeClients.length > 0 && (
                              <IconButton
                                onClick={() => {                             
                                  if (searchClientRef.current) {
                                    searchClientRef.current.value = ""; 
                                  }
                                }}
                              >
                                {/* <ClearIcon /> */}
                              </IconButton>
                            )}
                            {params.InputProps.endAdornment}
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
                {error && <Typography variant="body2" color="error">{error}</Typography>}
              </Grid>

              {hasLocations && (
              <Grid item xs={2}>
                <Autocomplete
                  multiple
                  fullWidth
                  id="locations"
                  options={locations}
                  value={[]}
                  getOptionLabel={(option) => 
                    option.selectall ? option.title : 
                    `${option.Location || option.name || ''}`
                  }
                  onChange={handleLocationChange}
                  disableCloseOnSelect={openLocationAuto}
                  open={openLocationAuto}
                  onOpen={() => setOpenLocationAuto(true)}
                  onClose={() => setOpenLocationAuto(false)}
                  filterOptions={filterLocationOptions}
                  renderOption={(props, option, { selected }) => {
                    const key = `locid-${option.ID || option.id || Math.random()}`;
                    return (
                      <li {...props} key={key}>
                        {option.selectall ? (
                          <>
                            <Checkbox
                              icon={iconLocation}
                              checkedIcon={checkedIconLocation}
                              style={{ marginRight: 8 }}
                              checked={locations.length > 0 && selectedLocations.length === locations.length}
                            />
                            {option.title}
                          </>
                        ) : (
                          <>
                            <Checkbox
                              icon={iconLocation}
                              checkedIcon={checkedIconLocation}
                              style={{ marginRight: 8 }}
                              checked={selectedLocations.includes(option.ID || option.id)}
                              onChange={() => {
                                const locId = option.ID || option.id;
                                const isChecked = selectedLocations.includes(locId);
                                const newSelectedLocations = isChecked
                                  ? selectedLocations.filter((id) => id !== locId)
                                  : [...selectedLocations, locId];
                                setSelectedLocations(newSelectedLocations);
                              }}
                            />
                            {`${option.Location || option.name || ''}`}
                          </>
                        )}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField 
                      {...params} 
                      label="Locations" 
                      onFocus={() => setOpenLocationAuto(true)}
                      error={locationError ? true : false}
                    />
                  )}
                />
                {locationError && <Typography variant="body2" color="error">{locationError}</Typography>}
              </Grid>
              )}


              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    id="agent-name"
                    variant="outlined"
                    value={agentName}
                    label="Profile Name"
                    onChange={(e) => handleAgentNameChange(e, "add")}
                    error={agentNameError ? true : false}
                  />
                  {agentNameError && <Typography color="error" variant="body2"  >{agentNameError}</Typography>}
                </FormControl>
              </Grid>


              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    id="userdisplayName"
                    label="User Name"
                    variant="outlined"
                    value={userNewName}
                    onChange={(e) => handleUsername(e, "add")}
                    error={userNewNameError ? true : false}

                  />
                  {userNewNameError && <Typography color="error" variant="body2"  >{userNewNameError}</Typography>}
                </FormControl>
              </Grid>

              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    name="userpassword"
                    label="Password"
                    onChange={(e) => handlePasswordChange(e, "add")}
                    value={password}
                    type={showPassword ? 'text' : 'password'}
                    error={passwordError ? true : false}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                          </IconButton>
                        </InputAdornment>
                      ),
                      autoComplete: 'new-password'
                    }}
                  />
                  {passwordError && <Typography color="error" variant="body2"  >{passwordError}</Typography>}
                </FormControl>
              </Grid>

              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    fullWidth
                    name="userpassword"
                    label="Confirm Password"
                    onChange={(e) => handleConfirmPasswordChange(e, "add")}
                    value={confirmPassword}
                    type={showConfirmPassword ? 'text' : 'password'}
                    error={confirmPasswordError ? true : false}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton edge="end" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                            <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {confirmPasswordError && <Typography color="error" variant="body2"  >{confirmPasswordError}</Typography>}



                </FormControl>
              </Grid>

              <Grid item xs={2}>
                <FormControl fullWidth>
                  <TextField
                    id="email"
                    label="Email"
                    variant="outlined"
                    value={email}
                    onChange={(e)=>handleEmailChange(e,"add")}
                    error={emailError  ? true : false }  
                  />
                {emailError && <Typography color="error" variant="body2"  >{emailError}</Typography>}
                </FormControl>
              </Grid>

              <Grid item md={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-labell">Email Authentication</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={IsNeed2FAAuthentication}
                    label="Email Authentication"
                    onChange={(e)=>handleAuthenicationChange(e,"add")}
                  >
                    
                    <MenuItem sx={{
                              '&.Mui-selected': {
                                  backgroundColor: 'rgba(143, 148, 148, 0.91)'
                              }
                          }}  value="1">Required</MenuItem>
                    <MenuItem sx={{
                              '&.Mui-selected': {
                                  backgroundColor: 'rgba(143, 148, 148, 0.91)'
                              }
                          }}  value="0">Not Required</MenuItem>

                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={2} sx={{ height: "100%", marginTop: 2 }}>
                <Button variant="contained" onClick={handleSubmit} disabled={isButtonDisabled}>
                  Add
                </Button>
                <Button color="error" variant="contained" onClick={handleClear} sx={{ marginLeft: 1 }}>
                  Clear
                </Button>

              </Grid>
            </Grid>

            <Grid
              container
              spacing={3}
              alignItems="center"
              sx={{ marginTop: "1rem", marginLeft:"0rem", width:'100%' }}
            >
              <Scrollbar>
                <TableContainer
                >

                  <Table stickyHeader>
                    <TableHead sx={{ background: (theme) => theme.palette.action.hover }}>
                      <TableRow sx={{ background: (theme) => theme.palette.action.hover }}>
                        <TableCell>SNo</TableCell>
                        <TableCell>Client</TableCell>
                        <TableCell>Location</TableCell>
                        <TableCell>Profile Name</TableCell>
                        <TableCell>User Name</TableCell>
                        <TableCell>Password</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Email Authentication</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* Your table rows go here */}
                      {subLoginSelect.map((data, index) => (
                        <TableRow key={index}
                        // style={{ backgroundColor: data.Status === 0 ? '#F5B7B1' : 'inherit' }}
                        >
                          <TableCell>{index + 1}</TableCell>
                          {/* <TableCell>{data.ID}</TableCell> */}
                          <TableCell>
                            {/* {data.length>0 && data.ClientName.map(client => (
                              <>
                                <span>{client}</span>
                                <br />
                              </>
                            ))} */}
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                {getClientLabelsForRow(data).map((client, i) => (
                                  <span key={i}>{client}</span>
                                ))}
                              </div>
                          </TableCell>
                          {/* <TableCell>{data.UserType === 4 ? "Agent" :data.UserType === 3 ? "Supervisor" : data.UserType ===  9 ? 'Deployment':'' }</TableCell> */}
                          <TableCell>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              {formatLocationsForDisplay(data.Location).map((location, i) => (
                                <span key={i}>{location}</span>
                              ))}
                            </div>
                          </TableCell>
                          <TableCell>{data.DisplayName}</TableCell>
                          <TableCell>{data.UserName}</TableCell>

                          <TableCell>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Typography variant="body2" style={{ marginRight: 8 }}>
                                {visiblePasswordIndex === index ? data.Password : '••••••••'}
                              </Typography>
                              <IconButton
                                onClick={() => handlePasswordVisibilityToggle(index)}
                                edge="end"
                              >
                                {visiblePasswordIndex === index ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </div>
                          </TableCell>

                          <TableCell>{data.Email}</TableCell>
                          <TableCell>{ (data.IsNeed2FAAuthentication === 0) ? "Not Required" : "Required"}</TableCell>


                          <TableCell>
                            <Grid container spacing={2}>
                              <Grid item>
                                <Button
                                  disabled={data.Status === 0}
                                  variant="contained"
                                  color="primary"
                                  sx={{
                                    bgcolor: data.Status === 0 ? 'action.disabledBackground' : undefined,
                                    color: data.Status === 0 ? 'text.disabled' : undefined,
                                  }}
                                  onClick={() => handleEdit(data)}>
                                  Edit
                                </Button>
                              </Grid>

                              <Grid item>
                                <Button
                                  variant="contained"
                                  color={data.Status === 1 ? 'error' : 'success'}
                                  onClick={() => handleDisable(data)}
                                >
                                  {data.Status === 1 ? "Disable" : "Enable"}
                                </Button>
                              </Grid>
                            </Grid>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
            </Grid>

            <Dialog open={openDialogEdit} onClose={handleClose} fullWidth={fullWidth} maxWidth={maxWidth}>
              <DialogContent>

                <Grid container spacing={2} alignItems="center">
                  <Grid container spacing={2} alignItems="center" marginTop={4}>


                    <Grid item xs={3}>


                      {/* <Autocomplete
                    multiple
                    fullWidth
                    id="clientEdit"
                    options={clientList}
                    value={[]}
                    getOptionLabel={(option) =>
                      option.selectall && clientList.length === activeClients.length
                        ? 'Select All'
                        : `${option.displayname}`
                    }
                    onChange={(e)=>handleClientChange(e,"edit")}
                    disableCloseOnSelect={openEditClientAuto}
                    open={openEditClientAuto}
                    onOpen={() => setOpenEditClientAuto(true)}
                    onClose={() => setOpenEditClientAuto(false)}
                    filterOptions={filterOptions}
                    renderOption={(props, option, { selected }) => {
                      const key = `camid-${option.ID}`;
                      
                      const handleCheckboxChange = () => {
                        const isChecked = activeClients.includes(option.ID);
                        const newActiveClients = isChecked
                          ? activeClients.filter((clientId) => clientId !== option.ID)
                          : [...activeClients, option.ID];
                        setActiveClients(newActiveClients);
                      };

                      return (
                        <li
                          {...props}
                          key={key}
                          onClick={(event) => {
                            event.preventDefault(); // Prevent default behavior (like closing the dropdown)
                            handleCheckboxChange(); // Trigger checkbox change
                          }}
                        >
                          <Checkbox
                            icon={iconClient}
                            checkedIcon={checkedIconClient}
                            style={{ marginRight: 8 }}
                            checked={
                              option.selectall
                                ? activeClients.length === clientList.length
                                : editedData.UserID.includes(option.ID) || activeClients.includes(option.ID)
                            }
                          />
                          {option.selectall ? option.title : option.displayname}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Client"
                        onFocus={() => setOpenEditClientAuto(true)}
                        error={error ? true : false}
                      />
                    )}
                  /> */}

                      {/* <Autocomplete
          multiple
          fullWidth
          id="clientEdit"
          options={clientList}
          value={[]}
          getOptionLabel={(option) =>
            option.selectall && clientList.length === activeSelectedClients.length
              ? 'Select All'
              : `${option.displayname}`
          }
          onChange={(e) => handleClientChange(e, 'edit')}
          disableCloseOnSelect
          renderOption={(props, option, { selected }) => {
            const key = `camid-${option.ID}`;

            const handleCheckboxChange = () => {
              const isChecked = activeSelectedClients.includes(option.ID);
              const newSelectedClients = isChecked
                ? activeSelectedClients.filter((clientId) => clientId !== option.ID)
                : [...activeSelectedClients, option.ID];
              setActiveSelectedClients(newSelectedClients);
            };

            return (
              <li
                {...props}
                key={key}
                onClick={(event) => {
                  event.preventDefault(); // Prevent dropdown from closing
                  handleCheckboxChange(); // Update selection
                }}
              >
                <Checkbox
                  style={{ marginRight: 8 }}
                  checked={activeSelectedClients.includes(option.ID)}
                />
                {option.displayname}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Client"
              onFocus={() => {}}
            />
          )}
        /> */}


                      <Autocomplete
                        multiple
                        fullWidth
                        id="clientEdit"
                        options={sortedClients}
                        value={[]}
                        getOptionLabel={(option) =>
                          option.selectall && sortedClients.length === activeSelectedClients.length
                            ? 'Select All'
                            : formatClientWithLocation(option)
                        }
                        inputValue={inputSearch} 
                        onInputChange={handleInputChange}
                        onChange={(e) => handleClientChange(e, 'edit')}
                        disableCloseOnSelect
                        renderOption={(props, option, { selected }) => {
                          const key = `camid-${option.ID}`;

                          const handleCheckboxChange = () => {
                            const isChecked = activeSelectedClients.includes(option.ID);
                            const newSelectedClients = isChecked
                              ? activeSelectedClients.filter((clientId) => clientId !== option.ID)
                              : [...activeSelectedClients, option.ID];
                            setActiveSelectedClients(newSelectedClients);
                          };

                          return (
                            <li
                              {...props}
                              key={key}
                              onClick={(event) => {
                                event.preventDefault(); // Prevent dropdown from closing
                                handleCheckboxChange(); // Update selection
                              }}
                            >
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={activeSelectedClients.includes(option.ID)}
                              />
                              {formatClientWithLocation(option)}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Client"
                            inputRef={searchRef}
                            onFocus={() => { }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <InputAdornment position="end">
                                  {activeSelectedClients.length > 0 && (
                                    <IconButton
                                      onClick={() => {
                                        ////setCheckClientValue(false)
                                        //setClientMatchedCameras([])
                                        //setActiveClients([]); // Clear the selected client
                                        //setInputSearch(''); 
                                        if (searchRef.current) {
                                          searchRef.current.value = ""; 
                                        }
                                      }}
                                    >
                                      {/* <ClearIcon /> */}
                                    </IconButton>
                                  )}
                                  {params.InputProps.endAdornment}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      />



                      {editclientError && <Typography variant="body2" color="error">{editclientError}</Typography>}
                    </Grid>

                    {hasEditLocations && (
                    <Grid item xs={3}>
                      <Autocomplete
                        multiple
                        fullWidth
                        id="edit-locations"
                        options={editLocations}
                        value={[]}
                        getOptionLabel={(option) =>
                          option.selectall ? option.title :
                          `${option.Location || option.name || ''}`
                        }
                        onChange={handleEditLocationChange}
                        disableCloseOnSelect={openEditLocationAuto}
                        open={openEditLocationAuto}
                        onOpen={() => setOpenEditLocationAuto(true)}
                        onClose={() => setOpenEditLocationAuto(false)}
                        filterOptions={filterEditLocationOptions}
                        renderOption={(props, option) => {
                          const key = `edit-locid-${option.ID || option.id || Math.random()}`;
                          return (
                            <li {...props} key={key}>
                              {option.selectall ? (
                                <>
                                  <Checkbox
                                    icon={iconLocation}
                                    checkedIcon={checkedIconLocation}
                                    style={{ marginRight: 8 }}
                                    checked={editLocations.length > 0 && editSelectedLocations.length === editLocations.length}
                                  />
                                  {option.title}
                                </>
                              ) : (
                                <>
                                  <Checkbox
                                    icon={iconLocation}
                                    checkedIcon={checkedIconLocation}
                                    style={{ marginRight: 8 }}
                                    checked={editSelectedLocations.includes(option.ID || option.id)}
                                    onChange={() => {
                                      const locId = option.ID || option.id;
                                      const isChecked = editSelectedLocations.includes(locId);
                                      const newSelectedLocations = isChecked
                                        ? editSelectedLocations.filter((id) => id !== locId)
                                        : [...editSelectedLocations, locId];
                                      setEditSelectedLocations(newSelectedLocations);
                                    }}
                                  />
                                  {`${option.Location || option.name || ''}`}
                                </>
                              )}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Locations"
                            onFocus={() => setOpenEditLocationAuto(true)}
                            error={editLocationError ? true : false}
                          />
                        )}
                      />
                      {editLocationError && <Typography variant="body2" color="error">{editLocationError}</Typography>}
                    </Grid>
                    )}


                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <TextField
                          id="agent-name"
                          variant="outlined"
                          value={editedData.agentName}
                          label="Name"
                          onChange={(e) => handleAgentNameChange(e, "edit")}
                          error={editProfileNameError ? true : false}
                        />
                    {editProfileNameError && <Typography color="error" variant="body2"  >{editProfileNameError}</Typography>}

                      </FormControl>
                    </Grid>
                    

                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <TextField
                          id="userdisplayName"
                          label="User Name"
                          variant="outlined"
                          value={editedData.userNewName}
                          onChange={(e) => handleUsername(e, "edit")}
                          error={editNameError ? true : false}
                        />
                        {editNameError && <Typography color="error" variant="body2"  >{editNameError}</Typography>}

                      </FormControl>
                      {/* {editNameError && (<Typography color='error' fontSize={12}>{editNameError}</Typography>)} */}
                    </Grid>

                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <TextField
                          id="userpassword"
                          label="Password"
                          variant="outlined"
                          value={editedData.password}
                          onChange={(e) => handlePasswordChange(e, "edit")}
                          error={editedPasswordError ? true : false}
                        />
                        {editedPasswordError && <Typography color="error" variant="body2"  >{editedPasswordError}</Typography>}
                      </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <TextField
                          id="confirmPassword"
                          label="Confirm Password"
                          variant="outlined"
                          value={editedData.confirmPassword}
                          onChange={(e) => handleConfirmPasswordChange(e, "edit")}
                          error={editedConfirmPasswordError ? true : false}
                        />
                        {editedConfirmPasswordError && <Typography color="error" variant="body2"  >{editedConfirmPasswordError}</Typography>}
                      </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                      <FormControl fullWidth>
                        <TextField
                          id="email"
                          label="Email"
                          variant="outlined"
                          value={editedData.Email}
                          onChange={(e)=>handleEmailChange(e,"edit")}
                          error={editEmailError  ? true : false }  
                        />
                      {editEmailError && <Typography color="error" variant="body2"  >{editEmailError}</Typography>}
                      </FormControl>
                    </Grid>

                    <Grid item md={3}>
                        <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-labell">Email Authentication</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={editedData.IsNeed2FAAuthentication}
                          label="Email Authentication"
                          onChange={(e)=>handleAuthenicationChange(e,"edit")}
                        >
                          
                          <MenuItem sx={{
                                    '&.Mui-selected': {
                                        backgroundColor: 'rgba(143, 148, 148, 0.91)'
                                    }
                                }}  value="1">Required</MenuItem>
                          <MenuItem sx={{
                                    '&.Mui-selected': {
                                        backgroundColor: 'rgba(143, 148, 148, 0.91)'
                                    }
                                }}  value="0">Not Required</MenuItem>

                      </Select>
                      {clientTypeerror  && <Typography variant="body2" color="error">{clientTypeerror}</Typography>}


                        </FormControl>
                        
                      
                    </Grid>


                    <Grid item xs={12} sx={{ height: "100%", textAlign: 'right' }}>
                      <Button color="error" variant="contained" onClick={handleClose}>
                        Close
                      </Button>
                      <Button variant="contained" sx={{ marginLeft: 1 }} onClick={handleUpdated}>
                        Save
                      </Button>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} alignItems="center" marginTop={4} marginLeft={1}>
                    {showMessage && (<Typography color="primary.main">Details Updated Successfully!!</Typography>)}
                  </Grid>
                </Grid>

                


              </DialogContent>
            </Dialog>



            <Dialog
              open={openMessage}
              onClose={handleClose}>
              <DialogContent>
                <Stack
                  //  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ maxWidth: 350, textAlign: "center" }}
                >
                  <Iconify
                    icon={"eva:alert-triangle-outline"}
                    sx={{ fontSize: 92, color: "warning.light" }}
                  />
                  <Typography sx={{ color: "text.secondary" }} variant="h5">
                    {" "}
                    Are you sure you want to {rowData.Status === 1 ? "Disable" : "Enable"}  the user :  {rowData.DisplayName}?
                  </Typography>
                </Stack>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  color="error"
                >
                  No
                </Button>
                <Button variant="contained" onClick={disableUser}>
                  Yes
                </Button>
              </DialogActions>
            </Dialog>

          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default ClientConsolidationLogin;
